import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Comuna } from '../models/Region/Comuna';
import { StandardResponse } from '../models/StandardResponseAPI';

@Injectable({
  providedIn: 'root'
})
export class MapaService {
  private REST_API_SERVER = environment.backend_server + "/mapa";
	constructor(private http: HttpClient) {}

  obtenerComunas(): Observable<Comuna[]> {
    return this.http.get<Comuna[]>(this.REST_API_SERVER + "/getList");
  }

  obtenerInformacionGeograficaPorDireccion(comunaId: number, direccion: string, numero: number): Observable<StandardResponse<any>> {
    const params = new HttpParams()
    .set('comunaId', comunaId.toString())
    .set('direccion', direccion)
    .set('numero', numero.toString());

    return this.http.get<StandardResponse<any>>(this.REST_API_SERVER + "/getInfo", { params });
  }

  obtenerInformacionGeograficaPorRol(comunaId: number, rol: string): Observable<StandardResponse<any>> {
    const params = new HttpParams()
    .set('comunaId', comunaId.toString())
    .set('rol', rol);

    return this.http.get<StandardResponse<any>>(this.REST_API_SERVER + "/getInfo/rol", { params });
  }
}
